// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"64842fc3","361":"168375db","488":"03655e10","691":"def2ea3c","767":"38012e7f","774":"267ba1bd"}[chunkId] + ".chunk.js";
};